import {screens} from './constants';
import getWindow from '@loggi/js/get-window';

const $window = __NATIVE__ ? {} : getWindow(); //TODO(renatoagds) return null and add checkers in methods

function getScreen() {
  const {innerWidth} = $window;

  return Object.keys(screens).reduce((currentScreen, key) => {
    const screen = screens[key];

    return (innerWidth >= screen) ? screen : currentScreen;
  }, null);
}

function hideMobileKeyboard() {
  if (isMobile()) {
    const fakeInput = document.createElement('input');
    document.body.appendChild(fakeInput);

    setTimeout(() => {
      fakeInput.focus();
      setTimeout(() => {
        fakeInput.setAttribute('style', 'display:none;')
      }, 50);
    }, 50);
  }
}

function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function isIos() {
  return /iPad|iPhone|iPod/.test($window.navigator.userAgent) && !$window.MSStream;
}

function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

export default {
  getScreen,
  isMobile,
  isIos,
  isAndroid,
  hideMobileKeyboard,
  sizes: screens
};
